
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import config from '@/config/index'
import { getProductDetail } from '@/api/youzheng.js'
import { wxShare, getWxConfig } from '@/libs/utils.js'
import errorImg from '@/assets/mall/img-error.png'
export default {
name: 'productdetail',
components: {
XButton,
Divider,
Swiper
},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
errorImg: errorImg,
id: this.$route.params.id,
goodsObj: {}
}
},
created () {
this.getDetail()
},
methods: {
onImgError ($event) {
$event.target.src = this.errorImg
},
getDetail () {
getProductDetail({
productid: this.id
}).then(res => {
this.goodsObj = res.returnValue
const link = window.location.href
const wxShareLink = this.baseUrl + 'servlet/ShareServlet?sicode=' + config.sicode + '&url=' + link
wxShare(res.returnValue.PRODNAME, wxShareLink, this.baseUrl + res.returnValue.TITLEIMG)
})
},
confirm () {
this.$router.push({ name: 'mallSubmitOrders', params: { id: this.id } })
}
}
}
